import {
  getFcherosOrigin,
  getFcherosOriginIfKnown,
  resolveFcherosOriginForLaunch,
} from '../config/fcheros';
import { getAuthToken } from './authStorage';

export const FCHEROS_SSO_LOGIN = 'gop-sso';
export const FCHEROS_SSO_LOGOUT = 'gop-sso-logout';
export const FCHEROS_SSO_ACK = 'gop-sso-ack';

const WINDOW_NAME = 'gop-ga-assistant';

let assistantWindow = null;
let origin = '';
let retryTimer = null;
let ackListener = null;
let loginAcked = false;

function isOpenWindow(target) {
  if (!target) return false;
  try {
    return !target.closed;
  } catch {
    return false;
  }
}

function stopRetry() {
  if (retryTimer) {
    clearTimeout(retryTimer);
    retryTimer = null;
  }
  if (ackListener) {
    window.removeEventListener('message', ackListener);
    ackListener = null;
  }
}

function postTo(target, message, targetOrigin) {
  if (!target || !targetOrigin) return;
  try {
    target.postMessage(message, targetOrigin);
  } catch {
    // 창이 이미 닫힌 경우
  }
}

function startLoginPost(target) {
  stopRetry();
  let attempts = 0;
  const post = () => {
    if (!target || target.closed) {
      stopRetry();
      return;
    }
    const token = getAuthToken();
    if (!token) return;
    postTo(target, { type: FCHEROS_SSO_LOGIN, token }, origin);
  };
  const schedule = () => {
    attempts += 1;
    post();
    if (attempts >= 20) return;
    retryTimer = window.setTimeout(schedule, 500);
  };
  ackListener = (event) => {
    if (event.origin !== origin) return;
    const data = event.data;
    if (data?.type === FCHEROS_SSO_ACK && data.ok && data.action === 'login') {
      loginAcked = true;
      stopRetry();
    }
  };
  window.addEventListener('message', ackListener);
  schedule();
}

/** GA비서 메뉴에서 FCHEROS를 새 창으로 열고 GOP 로그인 토큰을 전달한다. */
export function openFcherosWindow() {
  const token = getAuthToken();
  if (!token || typeof window === 'undefined') return false;

  if (isOpenWindow(assistantWindow)) {
    assistantWindow.focus();
    if (!loginAcked) startLoginPost(assistantWindow);
    return true;
  }

  loginAcked = false;
  const knownOrigin = getFcherosOriginIfKnown();
  const popup = window.open(knownOrigin ? `${knownOrigin}/ai-fc-heroes` : '', WINDOW_NAME);
  if (!popup) return false;
  assistantWindow = popup;
  if (knownOrigin) {
    origin = knownOrigin;
    startLoginPost(popup);
    return true;
  }

  resolveFcherosOriginForLaunch().then((nextOrigin) => {
    if (!isOpenWindow(popup)) return;
    origin = nextOrigin;
    let href = '';
    try {
      href = popup.location.href || '';
    } catch {
      href = nextOrigin;
    }
    if (!href.startsWith(nextOrigin)) {
      popup.location.href = `${nextOrigin}/ai-fc-heroes`;
    }
    startLoginPost(popup);
  });
  return true;
}

/** GOP 로그아웃 시 열려 있는 FCHEROS 창의 세션도 끊는다. */
export function logoutFcheros() {
  stopRetry();
  loginAcked = false;
  const targetOrigin = origin || getFcherosOrigin();
  const target = isOpenWindow(assistantWindow) ? assistantWindow : null;
  if (!target) {
    assistantWindow = null;
    return Promise.resolve();
  }
  postTo(target, { type: FCHEROS_SSO_LOGOUT }, targetOrigin);
  return new Promise((resolve) => {
    window.setTimeout(() => {
      assistantWindow = null;
      resolve();
    }, 300);
  });
}
